import React, { useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Input } from 'core-components/library/inputs'
import { FilterArea, IPanelContentProps } from 'core-components/library/list/filterArea'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'

interface IFilterAreaProps {
  source: Crud<IForm>
}

const PanelContent = (props: IPanelContentProps<IForm>) => {
  const filter = props.filter || { logic: Logic.AND, filters: [] }
  const orFilter: any = filter.filters.find(
    (el) => (el as IDataProviderFilter)['logic'] === Logic.OR
  )
  const value = orFilter ? orFilter.filters[0].value : ''
  const [inputValue, setInputValue] = useState(value)
  const fields = ['Country', 'CommunicationName', 'PartnerId']

  return (
    <div>
      <Input
        value={inputValue}
        onChange={(v) => {
          setInputValue(v)
          const newOrFilter = orFilter
            ? orFilter
            : {
                logic: Logic.OR,
                filters: [],
              }
          if (!orFilter) {
            filter.filters.push(newOrFilter)
          }
          newOrFilter.filters = fields.map((field) => ({
            field,
            operator: Operator.CONTAINS,
            value: v,
          }))
          props.onFilterChange(filter)
        }}
        label="Search..."
        autoFocus
      />
    </div>
  )
}

export const PartnersFilterArea = ({ source }: IFilterAreaProps) => {
  return (
    <FilterArea<IForm>
      source={source}
      PanelContent={PanelContent}
      onFilterRender={(filter: any) => {
        if (filter && (filter as IDataProviderFilter)['logic'] === Logic.OR) {
          return <span>Search by "{filter.filters[0].value}"</span>
        }
        return undefined
      }}
    />
  )
}
